import React, { useContext, useReducer } from "react";
import { FormControl, Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { toast } from "react-toastify";
import { Store } from "../Store";
import useAxios from "../hooks/useAxios";
import { getError, turkishCurrencyFormatterNoPrecision } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_REQUEST":
      return { ...state, loadingUpdate: true };
    case "UPDATE_SUCCESS":
      return { ...state, loadingUpdate: false };
    case "UPDATE_FAIL":
      return { ...state, loadingUpdate: false };
    default:
      return state;
  }
};

export default function ChangePriceModal(props) {
  const {
    showChangePrice,
    setShowChangePrice,
    selectedProduct,
    priceChangeRate,
    setPriceChangeRate,
    selectedProductPrice,
    setSelectedProductPrice,
    table,
  } = props;

  const axios = useAxios();

  const { dispatch: ctxDispatch } = useContext(Store);

  const [{ loadingUpdate }, dispatch] = useReducer(reducer, {
    loadingUpdate: false,
  });

  const handlePriceChange = async () => {
    try {
      dispatch({ type: "UPDATE_REQUEST" });

      if (
        (!selectedProduct.feature && !selectedProductPrice) ||
        (selectedProduct.feature &&
          selectedProductPrice < selectedProduct.price)
      ) {
        toast.error("Girdiğiniz fiyat geçersizdir.");
        return;
      }

      dispatch({ type: "UPDATE_REQUEST" });
      await axios.put(`/api/customer/orders/item/${selectedProduct.itemCode}`, {
        quantity: selectedProduct.quantity,
        price: selectedProductPrice,
      });

      ctxDispatch({
        type: "CART_CHANGE_ITEM_PRICE",
        payload: {
          price: selectedProductPrice,
          item: selectedProduct,
          tableNum: table,
        },
      });
      setShowChangePrice(false);

      dispatch({ type: "UPDATE_SUCCESS" });
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };

  return (
    <Modal
      backdrop="static"
      centered
      size="sm"
      show={showChangePrice}
      onHide={() => setShowChangePrice(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {selectedProduct.feature ? selectedProduct.feature.name + " " : ""}
          {selectedProduct.name} Fiyat
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <Form.Check
            checked={priceChangeRate === 1}
            onChange={(e) => setPriceChangeRate(1)}
            inline
            label="₺1"
            name="group1"
            type="radio"
          />
          <Form.Check
            checked={priceChangeRate === 5}
            onChange={(e) => setPriceChangeRate(5)}
            inline
            label="₺5"
            name="group1"
            type="radio"
          />
          <Form.Check
            checked={priceChangeRate === 10}
            onChange={(e) => setPriceChangeRate(10)}
            inline
            label="₺10"
            name="group1"
            type="radio"
          />
          <Form.Check
            checked={priceChangeRate === 25}
            onChange={(e) => setPriceChangeRate(25)}
            inline
            label="₺25"
            name="group1"
            type="radio"
          />
        </div>

        <InputGroup style={{ width: "70%" }}>
          <Button
            onClick={() => {
              setSelectedProductPrice(selectedProductPrice - priceChangeRate);
            }}
            variant="light"
            className="border-primary text-primary"
            disabled={
              !selectedProduct.feature
                ? selectedProductPrice - priceChangeRate < 0
                : selectedProductPrice - priceChangeRate < selectedProduct.price
            }
          >
            <span className="text-bold">-{priceChangeRate}</span>
          </Button>{" "}
          <FormControl
            type="text"
            value={"₺ " + selectedProductPrice}
            onChange={(e) => {
              setSelectedProductPrice(
                Number(e.target.value.substring(2)) || ""
              );
            }}
          ></FormControl>
          <Button
            variant="light"
            onClick={() => {
              setSelectedProductPrice(selectedProductPrice + priceChangeRate);
            }}
            className="border-primary text-primary"
          >
            <span className="text-bold">+{priceChangeRate}</span>
          </Button>
        </InputGroup>
        <small id="passwordHelpBlock" className="form-text text-muted">
          <span className="text-danger">
            Sadece bu satır için{" "}
            {selectedProduct.feature ? selectedProduct.feature.name + " " : ""}
            {selectedProduct.name}{" "}
            {turkishCurrencyFormatterNoPrecision(selectedProductPrice)}{" "}
            olacaktır
          </span>
        </small>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="light"
          className="text-primary border-primary"
          onClick={handlePriceChange}
        >
          Kaydet
        </Button>
        <Button
          variant="light"
          className="text-danger border-danger"
          onClick={() => setShowChangePrice(false)}
        >
          İptal
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
